import {createAction, createAsyncThunk, createReducer} from '@reduxjs/toolkit';

import {ENDPOINTS} from 'constants/endpoints';
import {PaymentTotalsType, OrderLastType} from 'desktop/pages/success/types/types';

import {RouterType} from 'hostApplicationStoreType';
import {apiConfig} from 'libs/api/api';

import {selectPopup} from './helpers/selectPopup';

export const defaultState: OrderLastType = {
    billing_address: {
        city: '',
        country_full: '',
        country_id: '',
        email: '',
        firstname: '',
        lastname: '',
        postcode: '',
        region: '',
        street: '',
        telephone: '',
    },
    directContribution: '',
    email: '',
    existedOrderBeforeToday: true,
    firstName: '',
    grandTotal: 0,
    id: '',
    isLoading: false,
    isNewCustomer: false,
    items: [],
    lastName: '',
    paymentMethodToken: '',
    popupVisible: false,
    selectedPopup: '',
    shipping_address: {
        city: '',
        country_full: '',
        country_id: '',
        email: '',
        firstname: '',
        lastname: '',
        postcode: '',
        region: '',
        street: '',
        telephone: '',
    },
    shippingAmount: 0,
    status: 'PENDING',
    taxAmount: 0,
    trackingToken: '',
    trustpilotQueryString: '',
    weights: [],
};

type GetOrderLastResponseDataType = {
    grandTotal: number;
    items: PaymentTotalsType[];
    paymentMethodToken: string;
    taxAmount: number;
    id: string;
};

/**
 * Open popup for payment
 * @param {boolean} flag - flag visibility popup
 * @return {ActionType<boolean>} Action
 */
export const openPopupPayment = createAction<boolean>('SUCCESS_PAGE@OPEN_POPUP_PAYMENT');

/**
 * Get list payments methods
 * @return {ActionType<GetOrderLastResponseDataType>} Action
 */
export const getOrderLast = createAsyncThunk<
    GetOrderLastResponseDataType,
    {
        router: RouterType;
    },
    {
        fulfilledMeta: {
            router: RouterType;
        };
    }
>('SUCCESS_PAGE@GET_LAST_ORDER', async (meta, {fulfillWithValue}) => {
    const response = await apiConfig.instanceGusaBackend({
        method: 'get',
        url: `${ENDPOINTS.GET_ORDER_LAST}`,
    });
    return fulfillWithValue(response.data, meta);
});

export const getExistOrderBeforeToday = createAsyncThunk<GetOrderLastResponseDataType, string>(
    'SUCCESS_PAGE@GET_PREVIOS_ORDER',
    orderId =>
        apiConfig.instanceGusaBackend.request({
            method: 'get',
            url: `${ENDPOINTS.ORDER_GET_PREVIOUS({order: orderId})}`,
        }),
);

export const setPopupLoading = createAction<boolean>('SUCCESS_PAGE@SET_POPUP_LOADING');

/**
 * Order last
 * @param {OrderLastType} state - reducer state
 * @param {AxiosPromise<OrderLastType>} action - order last items
 * @return {OrderLastType} - new state
 */
export const orderLast = createReducer(defaultState, builder => {
    builder
        .addCase(getOrderLast.fulfilled, (state: OrderLastType, action) => ({
            ...state,
            ...action.payload,
            selectedPopup: selectPopup({...state, ...action.payload}) as
                | ''
                | 'sitejabber'
                | 'bizrate'
                | 'reseller'
                | 'trustpilot',
            status: 'FULFILLED',
        }))
        .addCase(
            getOrderLast.pending,
            (state: OrderLastType): OrderLastType => ({
                ...state,
                selectedPopup: '',
                status: 'PENDING',
            }),
        )
        .addCase(
            getOrderLast.rejected,
            (state: OrderLastType): OrderLastType => ({
                ...state,
                selectedPopup: '',
                status: 'REJECTED',
            }),
        )
        .addCase(openPopupPayment, (state, action) => ({
            ...state,
            popupVisible: action.payload,
        }))
        .addCase(setPopupLoading, (state, action) => ({
            ...state,
            isLoading: action.payload,
        }))
        .addCase(getExistOrderBeforeToday.fulfilled, state => ({
            ...state,
            existedOrderBeforeToday: true,
        }))
        .addCase(getExistOrderBeforeToday.rejected, state => ({
            ...state,
            existedOrderBeforeToday: false,
        }));
});
